import {
  AloftDate,
  DatasetSource,
  MLSID,
  MLSListing,
  ToolkitListingID,
  ToolkitProperty,
  ToolkitPropertyRunner,
  formatToolkitRecordID,
  getToolkitListingID,
  identifyToolkitProperty,
  isDefined,
  isUndefined,
  mlsInfoByOriginatingSystemName,
  toolkitPropertyRunnerFactory,
} from '@aloft/toolkit-shared';

export const listingsToToolkitProperties = ({
  listings,
  source,
}: {
  listings: MLSListing[];
  source: DatasetSource;
}): ToolkitProperty[] => {
  const tkPropRunner: ToolkitPropertyRunner = toolkitPropertyRunnerFactory(source);

  return listings
    .map((listing) => {
      try {
        if (source === 'constellation1') {
          const mlsInfo = mlsInfoByOriginatingSystemName(listing.OriginatingSystemName);
          if (isUndefined(mlsInfo)) return undefined;

          const property = tkPropRunner(AloftDate.today(), listing, mlsInfo.mlsid);
          if (property.listingStatus !== 'SettledSale') return undefined;

          const listingID = getToolkitListingID(property);
          if (listingID === undefined) return undefined;

          // TODO: Use order ID
          const id = formatToolkitRecordID({
            orderID: 'paired-sales',
            location: { t: 'dataset', datasetID: 'paired-sales', listingID },
          });

          return identifyToolkitProperty(property, id);
        }

        if (source === 'abode') {
          const property = tkPropRunner(AloftDate.today(), listing, listing.MLSOUID as MLSID);

          if (property.listingStatus !== 'SettledSale') return undefined;

          const listingID = getToolkitListingID(property, true);
          property.toolkitListingID = listingID;

          const id = formatToolkitRecordID({
            orderID: 'paired-sales',
            location: {
              t: 'dataset',
              datasetID: 'paired-sales',
              listingID: listingID as ToolkitListingID,
            },
          });

          return identifyToolkitProperty(property, id);
        }
      } catch (error) {
        console.error(error, { listing });
      }

      return undefined;
    })
    .filter(isDefined);
};
